import { useState } from 'react'
import { putIdea } from '../apiCalls'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'

const EditIdea = (props) => {
    const idea = props.mods.idea
    const setEditToggle = props.mods.setEditToggle
    const getIdeas = props.mods.getIdeas

    const [ideaForm, setIdeaForm] = useState({
        name: idea.name,
        location: idea.location,
        details: idea.details
    })

    const handleChange = (e) => {
        setIdeaForm((baseState) => ({
            ...baseState,
            [e.target.name]: e.target.value
        }))
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault()
            await putIdea(ideaForm, idea._id)
            getIdeas()
            setEditToggle(false)

        } catch(err) {
            console.log(err)
        }
    }

    const handleClose = () => {
        setEditToggle(false)
    }

    return (
        <>
        <h2 className="">Edit Date</h2>
                <Form onSubmit={handleSubmit}>
                <Row>
                    <Form.Group className="sm-2" controlId="ideaName">
                        <Form.Label>Name: </Form.Label>
                        <Form.Control type='text' name="name" onChange={handleChange} value={ideaForm.name}></Form.Control>
                    </Form.Group>
                    <Form.Group className="sm-2" controlId="ideaDetails">
                        <Form.Label>Details: </Form.Label>
                        <Form.Control type='text' name="details" onChange={handleChange} value={ideaForm.details}></Form.Control>
                    </Form.Group>
                    <Form.Group className="sm-2" controlId="ideaLocation">
                        <Form.Label>Location: </Form.Label>
                        <Form.Control type='text' name="location" onChange={handleChange} value={ideaForm.location}></Form.Control>
                    </Form.Group>
                </Row>
                <Row className="inputButtonRow mt-2">
                    <Col className="d-flex justify-content-center">
                        <Button variant="dark" type="submit" className="defaultButton">Submit</Button>
                    </Col>
                    <Col>
                        <p type="button" onClick={handleClose}>Cancel</p>
                    </Col>
                </Row>
                </Form>
            </>
    )
}

export default EditIdea